import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, withModifiers as _withModifiers, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "header-global py-2" }
const _hoisted_2 = { class: "nav d-flex justify-content-end align-items-center" }
const _hoisted_3 = {
  key: 0,
  class: "navbar-nav m-2"
}
const _hoisted_4 = {
  key: 0,
  class: "nav-item me-3"
}
const _hoisted_5 = {
  key: 1,
  class: "navbar-nav me-3"
}
const _hoisted_6 = { class: "dropright" }
const _hoisted_7 = {
  type: "button",
  class: "header-dropdown",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}
const _hoisted_8 = { class: "dropdown-menu" }
const _hoisted_9 = {
  key: 2,
  class: "navbar-nav me-4 mt-0.5"
}
const _hoisted_10 = { class: "dropright" }
const _hoisted_11 = {
  type: "button",
  class: "header-dropdown user-button user-initial p-2",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}
const _hoisted_12 = { class: "user-initial" }
const _hoisted_13 = { class: "dropdown-menu" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoginOutlined = _resolveComponent("LoginOutlined")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_AppstoreOutlined = _resolveComponent("AppstoreOutlined")!
  const _component_LogoutOutlined = _resolveComponent("LogoutOutlined")!

  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (!_ctx.showSecure)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            (_ctx.showSignIn)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  (_ctx.isLoggedIn)
                    ? (_openBlock(), _createBlock(_component_router_link, {
                        key: 0,
                        to: "/landing",
                        class: "btn-header-signin"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_LoginOutlined, { class: "me-2" }),
                          _cache[3] || (_cache[3] = _createElementVNode("span", null, "Enter", -1))
                        ]),
                        _: 1
                      }))
                    : (_openBlock(), _createBlock(_component_router_link, {
                        key: 1,
                        to: "/login",
                        class: "btn-header-signin"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_LoginOutlined, { class: "me-2" }),
                          _cache[4] || (_cache[4] = _createElementVNode("span", null, "Sign In", -1))
                        ]),
                        _: 1
                      }))
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      (_ctx.showSecure)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("button", _hoisted_7, [
                _createVNode(_component_AppstoreOutlined, { class: "features-button" })
              ]),
              _createElementVNode("ul", _hoisted_8, [
                _cache[5] || (_cache[5] = _createElementVNode("li", null, [
                  _createElementVNode("h6", { class: "dropdown-header" }, "Dashboards")
                ], -1)),
                _createElementVNode("li", null, [
                  _createElementVNode("a", {
                    class: _normalizeClass(["dropdown-item", { 'active': _ctx.currentProduct === 'productcloud' }]),
                    href: "#",
                    onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.switchToDashboard('productcloud')), ["prevent"]))
                  }, " Product Cloud Dashboard ", 2)
                ]),
                _createElementVNode("li", null, [
                  _createElementVNode("a", {
                    class: _normalizeClass(["dropdown-item", { 'active': _ctx.currentProduct === 'bankwatch' }]),
                    href: "#",
                    onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.switchToDashboard('bankwatch')), ["prevent"]))
                  }, " BankWatch Dashboard ", 2)
                ]),
                _createElementVNode("li", null, [
                  _createElementVNode("a", {
                    class: _normalizeClass(["dropdown-item", { 'active': _ctx.currentProduct === 'cdrtest' }]),
                    href: "#",
                    onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.switchToDashboard('cdrtest')), ["prevent"]))
                  }, " CDR Test Suite Dashboard ", 2)
                ]),
                _cache[6] || (_cache[6] = _createElementVNode("li", null, [
                  _createElementVNode("hr", { class: "dropdown-divider" })
                ], -1)),
                _cache[7] || (_cache[7] = _createElementVNode("li", null, [
                  _createElementVNode("h6", { class: "dropdown-header" }, "External Links")
                ], -1)),
                _cache[8] || (_cache[8] = _createElementVNode("li", null, [
                  _createElementVNode("a", {
                    class: "dropdown-item",
                    href: "https://www.productcloud.com.au",
                    target: "_blank"
                  }, " ProductCloud ")
                ], -1)),
                _cache[9] || (_cache[9] = _createElementVNode("li", null, [
                  _createElementVNode("a", {
                    class: "dropdown-item",
                    href: "https://www.productcloud.com.au",
                    target: "_blank"
                  }, " ZenDesk Portal ")
                ], -1))
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.showSecure)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("button", _hoisted_11, [
                _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.userInitials), 1)
              ]),
              _createElementVNode("ul", _hoisted_13, [
                _createElementVNode("li", null, [
                  (_ctx.isLoggedIn)
                    ? (_openBlock(), _createBlock(_component_router_link, {
                        key: 0,
                        to: "/logout",
                        class: "dropdown-item btn btn-neutral btn-icon d-flex align-items-center"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_LogoutOutlined, { class: "me-2" }),
                          _cache[10] || (_cache[10] = _createElementVNode("span", null, "Log Out", -1))
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}